<template>
	<validation-provider
			:name="'AdminTextField-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			mode="lazy"
			v-slot="{ errors }">
		<v-text-field
				v-model="$store.state.admin.input[inputItemKey]"
				:disabled="contents[contentKey].inputItems[inputItemKey].disabled"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminTextField',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		}
	}
</script>

<style scoped>
</style>
